module.exports = __webpack_public_path__ + "img/iceskating001.69143303.jpg";